import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getSportGameLink = createAsyncThunk(
  "getSportGameLink",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post(
        "sportsbook/start-session",
        JSON.stringify(payload)
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "Something went wrong"
      );
    }
  }
);

const getSportGameLinkSlice = createSlice({
  name: "getSportGameLink",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSportGameLink.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSportGameLink.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSportGameLink.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getSportGameLinkSlice.reducer;
